// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, DestroyRef, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import multiDownload from 'multi-download';
import {UserService} from '../../../services/user-service';
import {D3eService} from '../../../services/d3e-service';
import { get_uuid_filename } from '../../../shared/subscription.methods';
import {ActionService} from '../../../services/action-service';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../../services/auth-service';


@Component({
    selector: 'app-d3e-download',
    templateUrl: './d3e-download.component.html',
    styleUrls: ['./d3e-download.component.scss'],
    standalone: false
})
export class D3eDownloadComponent implements OnInit {

  fThanks: string;

  constructor(
      private route: ActivatedRoute,
      private d3eService: D3eService,
      public userService: UserService,
      private actionService: ActionService,
      private translate: TranslateService,
      private readonly destroyRef: DestroyRef,
      private readonly authService: AuthService,
  ) {
    this.translate.get(['DL_THANKSB']).subscribe(vals => {
      this.fThanks = vals['DL_THANKSB'];
    });
  }

  ngOnInit() {
    this.authService.showNav.next(false);
    this.authService.showToolbar.next(false);
    this.authService.showBanners.next(false);

    this.route.params.subscribe(params => {
      this.d3eService.get_d3e_software_version(params.uuid)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(softwareVersion => {
        const filename = get_uuid_filename(softwareVersion, softwareVersion.system, params.uuid).split('/').pop();
        this.actionService.postDownloadBySubUUID(filename, params.uuid)
          .subscribe(() => {
            multiDownload([softwareVersion.path], {
              rename: () => filename,
          });
        });
      });
    });
  }

  isLoggedIn() {
    const token = localStorage.getItem('token');
    return token !== null;
  }
}
